import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const alertDeviceService = {
  get,
  getAlertDeviceByToken,
  stopDeviceAlarm,
  updateStatusAlertDevice,
  publicGetByToken,
  publicUpdateStatus,
  updateAlarmRequest,
};

function get(propertyId,page,pageSize,expand = ''){
  expand = expand ? `&expand=${expand}` : '';
  return (
    axios
      .get(
        `${apiEndpoint.alertDevice}?property_id=${propertyId}&page=${page}&page_size=${pageSize}${expand}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getAlertDeviceByToken(token){
  return (
    axios
      .get(
        `${apiEndpoint.alertDevice}/get-by-token?token=${token}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        return res.data;
      })
  );
}

function stopDeviceAlarm(data){
  return (
    axios
      .post(
        `${apiEndpoint.alertDevice}/stop-alarm-device`,
        data,
        {
          headers: authHeader()
        }
    )
    .then(res => {
      if(res && res.status === 200){
        return res.data;
      }
      return {};
  }));
}
function updateStatusAlertDevice(data){
  return (
    axios
      .post(
        `${apiEndpoint.alertDevice}/update-status-alert-device`,
        data,
        {
          headers: authHeader()
        }
    )
    .then(res => {
      if(res && res.status === 200){
        return res.data;
      }
      return {};
  }));
}

// Public SMS response endpoints — no auth header. A stale local token
// would only confuse the backend (which doesn't gate this action on
// the user anyway); send the request anonymous.
function publicGetByToken(token){
  return axios
    .get(`${apiEndpoint.alertDevice}/public-get-by-token?token=${encodeURIComponent(token)}`)
    .then(res => res.data);
}

function publicUpdateStatus(data){
  return axios
    .post(`${apiEndpoint.alertDevice}/public-update-status`, data)
    .then(res => res.data);
}

function updateAlarmRequest(data){
  return (
    axios
      .post(
        `${apiEndpoint.alertDevice}/update-alarm-request`,
        data,
        {
          headers: authHeader()
        }
    )
    .then(res => {
      if(res && res.status === 200){
        return res.data;
      }
      return {};
  }));
}

